import {HpoTransportStatus} from "../../../choices";
import {interpolate, ngettext} from "../../../../../utils/translate";


export function patientInHospital(patient) {
  try {
    return !!patient.transport.lastDestinationRequest.inHospitalTimestamp
  } catch (e) {
  }
  return false
}

export function patientTransported(patient) {
  try {
    return !patientInHospital(patient) && (patient.transport.lastDestinationRequest.lastReply.status === HpoTransportStatus.ACCEPTED)
  } catch (e) {
  }
  return false
}

const getEtaMinutes = (eta, transportMinutes, now) => {
  if (eta) {
    return eta.diff(now, 'minute')
  }
  if (transportMinutes != null) {  // was: if (transportMinutes)
    return transportMinutes
  }
  return null
}


export const getRemainingTimeMessage = (eta, transportMinutes, now) => {
  const etaMinutes = getEtaMinutes(eta, transportMinutes, now);

  if (etaMinutes !== null) {
    const absMinutes = Math.abs(etaMinutes);

    if (etaMinutes >= 0) {
      return interpolate(
        ngettext(
          'arrival in %(absMinutes)s minute',
          'arrival in %(absMinutes)s minutes',
          absMinutes
        ),
        {absMinutes: absMinutes}
      );
    }

    return interpolate(
      ngettext(
        'arrival %(absMinutes)s minute ago',
        'arrival %(absMinutes)s minutes ago',
        absMinutes
      ),
      {absMinutes: absMinutes}
    );
  }

  return null;
};